export default "__VITE_ASSET__Y0Kg4Bnp__"